<template>
<div class="shadow-box">
  <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-right: 0;">
    <div>
      <span>渠道用户管理</span>
    </div>
    <span>
      <el-button type="primary" v-if="roleType === 1" icon="el-icon-edit" @click="showTagsManageDialog = true">渠道标签管理</el-button>
      <el-button type="primary" @click="showBatchEditDialog = true">批量修改</el-button>
    </span>
  </div>
  <el-dialog :close-on-click-modal="false" :visible.sync="showBatchEditDialog" title="批量修改" width="600px">
    <div class="batch-edit" style="padding-bottom: 16px;">
      <div>选择一级渠道：</div>
      <el-select
        v-model="qdAccountId0"
        ref="qdSelect"
        clearable
        filterable
        placeholder="请选择" style="width: 354px;">
        <el-option v-for="item in groupList1"
          :key="item.accountId"
          :value="item.accountId"
          :label="item.name"></el-option>
      </el-select>
    </div>
    <div class="batch-edit">
      <div>批量将二级渠道高佣商品佣金比例 =</div>
      <el-input class="input" v-model="batchEditForm.oldBd" clearable
        placeholder="78%填写78"
        @input="validateNumberInput('oldBd', $event)"></el-input>
      <div> 改为 </div>
      <el-input  class="input" v-model="batchEditForm.newBd" clearable
        placeholder="78%填写78"
        @input="validateNumberInput('newBd', $event)"></el-input>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="text" @click="batchEditFormClear(); showBatchEditDialog = false;">取消</el-button>
      <el-button type="primary" @click="batchEditSubmit">保存</el-button>
    </div>
  </el-dialog>
  <div class="row-box">
    <el-row :gutter="16">
      <el-col :span="10">
        <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-bottom: 6px;">
          <div class="flex-row">
            <span>一级渠道列表</span>
          </div>
        </div>
        <div class="page-main_box">
          <div class="flex-row search-box">
            <div class="search-item">
              <el-input v-model="form1.mobilePhone" style="width: 100px;" @blur="getList" @clear="getList" clearable placeholder="渠道账号"></el-input>
            </div>
            <div class="search-item">
              <el-input v-model="form1.nickName" style="width: 100px;" @blur="getList" @clear="getList" clearable placeholder="渠道昵称"></el-input>
            </div>
            <div class="search-item">
              <el-select v-model="form1.tagCode" clearable  filterable placeholder="渠道标签" style="width: 100px;">
                <el-option v-for="item in tagList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <el-select v-model="form1.hasTag" clearable  filterable placeholder="是否打标" style="width: 95px;">
                <el-option v-for="item in isOrNot"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="getList1">查询</el-button>
          </div>
          <div class="code-list">
            <el-table
              row-key="id"
              border
              stripe
              style="width: 100%;"
              height="calc(100vh - 334px)"
              :data="tableData1"
              highlight-current-row
              ref="tableData1Ref"
              :row-class-name="tableRowClassName"
              @current-change="handleCurrentChange"
              @select="handleSelect1"
              @select-all="handleSelectAll1"
              v-loading="isLoading1" >
              <el-table-column
                type="selection"
                reserve-selection
                fixed
                width="55">
              </el-table-column>
              <el-table-column
                prop="mobilePhone"
                label="渠道账号"
                min-width="120">
              </el-table-column>
              <el-table-column
                prop="nickName"
                label="渠道昵称"
                min-width="120">
              </el-table-column>
              <el-table-column
                prop="qdTagLabels"
                label="渠道标签"
                min-width="100">
                <template slot-scope="{ row }">
                  <div v-if="row.qdTagLabels && row.qdTagLabels.length">
                    {{ row.qdTagLabels.join('; ') }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="180">
                <template slot-scope="{ row }">
                  <div>
                    <el-button type="text" @click="editHander({...row, editType: 1})">编辑</el-button>
                    <el-button type="text"
                      v-clipboard:copy="row.cOrderLink"
                      v-clipboard:success="() => $message.success('复制成功')">复制移动端报单链接</el-button> 
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="batch-btn">
              <span>共勾选 <b style="font-size: 14px;">{{ multipleSelection1.length }}</b> 条</span>
              <el-button type="text" v-if="multipleSelection1.length" @click="clearSelect('tableData1Ref', 'multipleSelection1')">清空选择</el-button>
              <el-button @click="batchEditTag({
                type: 1,
                editType: 1,
                list: multipleSelection1
              })" :disabled="!multipleSelection1.length" size="mini">批量新增渠道标签</el-button>
              <el-button @click="batchEditTag({
                type: 1,
                editType: 2,
                list: multipleSelection1
              })" :disabled="!multipleSelection1.length" size="mini">批量删除渠道标签</el-button>
            </div>
            <div class="bd--pag">
              <el-pagination
                class="d-ib"
                background
                layout="total, prev, pager, next"
                :total="pageInfo1.total"
                :page-sizes="pageInfo1.sizes"
                :page-size="pageInfo1.size"
                :current-page="pageInfo1.current"
                @current-change="pageInfo1.current = arguments[ 0 ], getList1()"
                @size-change="pageInfo1.size = arguments[ 0 ], getList1()">
              </el-pagination>
            </div> 
          </div>
        </div>
      </el-col>
      <el-col :span="14">
        <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-bottom: 6px;">
          <div class="flex-row">
            <span v-if="currentRow">
              {{ currentRow.nickName }}
              <span v-if="currentRow.mobilePhone">（{{ currentRow.mobilePhone }}）</span>
            </span>
            <span v-else>二级渠道列表
            </span>
          </div>
        </div>
        <div class="page-main_box">
          <div class="flex-row search-box">
            <div class="search-item">
              <el-input v-model="form.mobilePhone" style="width: 120px;" @blur="getList" @clear="getList" clearable placeholder="渠道账号"></el-input>
            </div>
            <div class="search-item">
              <el-input v-model="form.nickName" style="width: 120px;" @blur="getList" @clear="getList" clearable placeholder="渠道昵称"></el-input>
            </div>
            <div class="search-item">
              <el-date-picker
                v-model="form.createDate"
                style="flex: 1; width: 180px;"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :clearable="roleType == 1"
                :picker-options="reportDateOptions"
                @change="goSearch">
              </el-date-picker>
            </div>
            <div class="search-item">
              <el-select v-model="form.tagCode" clearable  filterable placeholder="渠道标签" style="width: 120px;">
                <el-option v-for="item in tagList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <el-select v-model="form.hasTag" clearable  filterable placeholder="是否打标" style="width: 95px;">
                <el-option v-for="item in isOrNot"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="getList">查询</el-button>
          </div>  
          <div class="code-list">
            <el-table
              row-key="id"
              border
              stripe
              style="width: 100%;"
              height="calc(100vh - 334px)"
              :data="tableData"
              v-loading="isLoading"
              ref="tableDataRef"
              @select="handleSelect"
              @select-all="handleSelectAll"
              @selection-change="handleSelectionChange">
              <el-table-column
                type="selection"
                reserve-selection
                fixed
                width="55">
              </el-table-column>
              <el-table-column
                prop="parentMobilePhone"
                label="一级渠道账号"
                min-width="120">
              </el-table-column>
              <el-table-column
                prop="parentNickName"
                label="一级渠道昵称"
                min-width="120">
              </el-table-column>
              <el-table-column
                prop="mobilePhone"
                label="二级渠道账号"
                min-width="120">
              </el-table-column>
              <el-table-column
                prop="nickName"
                label="二级渠道昵称"
                min-width="120"> 
              </el-table-column>
              <el-table-column
                prop="qdTagLabels"
                label="渠道标签"
                min-width="120">
                <template slot-scope="{ row }">
                  <div v-if="row.qdTagLabels && row.qdTagLabels.length">
                    {{ row.qdTagLabels.join('; ') }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="bd"
                min-width="140"
                label="高佣商品佣金比例">
                <template slot-scope="{ row }">
                  <div v-if="row.userPromotion && row.userPromotion.bd">
                    {{ (row.userPromotion.bd / 1000).toFixed(2) + '%' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="bd"
                min-width="220">
                <template slot="header" slot-scope="scope">
                  <div>高佣商品一级渠道固定扣点(%)
                    <el-tooltip effect="dark"  placement="top">
                      <template slot="content">
                        设置后，该二级渠道在选品库看到的佣金比例会<br />自动比一级渠道少几个点，并且报单后会按此结算
                      </template>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </template>
                <template slot-scope="{ row }">
                  <div v-if="row.userPromotion && row.userPromotion.bdChannelDeduction >= 0">
                    {{ (row.userPromotion.bdChannelDeduction / 1000).toFixed(2) + '%' }}
                  </div>
                </template>
              </el-table-column> 
              <el-table-column
                prop="accountStatus"
                label="状态"
                show-overflow-tooltip
                min-width="140">
                <template slot-scope="{ row }">
                  <el-switch :value="row.account.accountStatus"
                    active-color="#0076F6"
                    inactive-color="#f4f5f7"
                    @change="e => flagChange(e, row)"
                    :active-value="'show'"
                    :inactive-value="'del'">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="创建日期"
                show-overflow-tooltip
                min-width="160">
                <template slot-scope="{ row }">
                  <div>
                    {{ row.createTime | filterDate }}
                  </div>
                </template>
              </el-table-column> 
              <el-table-column
                fixed="right"
                label="操作"
                width="180">
                <template slot-scope="{ row }">
                  <div>
                    <el-button type="text" @click="editHander({...row, editType: 2})">编辑</el-button>
                    <el-button type="text"
                      v-clipboard:copy="row.cOrderLink"
                      v-clipboard:success="() => $message.success('复制成功')">复制移动端报单链接</el-button> 
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="batch-btn">
              <span>共勾选 <b style="font-size: 14px;">{{ multipleSelection.length }}</b> 条</span>
              <el-button type="text" v-if="multipleSelection.length" @click="clearSelect('tableDataRef', 'multipleSelection')">清空选择</el-button>

              <el-button @click="batchEditTag({
                  type: 2,
                  editType: 1,
                  list: multipleSelection
                })" :disabled="!multipleSelection.length" size="mini">批量新增渠道标签</el-button>
              <el-button @click="batchEditTag({
                type: 2,
                editType: 2,
                list: multipleSelection
              })"  :disabled="!multipleSelection.length" size="mini">批量删除渠道标签</el-button>
            </div>
            <div class="bd--pag">
              <el-pagination
                class="d-ib"
                background
                layout="total, prev, pager, next, jumper"
                :total="pageInfo.total"
                :page-sizes="pageInfo.sizes"
                :page-size="pageInfo.size"
                :current-page="pageInfo.current"
                @current-change="pageInfo.current = arguments[ 0 ], getList()"
                @size-change="pageInfo.size = arguments[ 0 ], getList()">
              </el-pagination>
            </div> 
          </div>
        </div>
        <!-- <div v-else style="padding: 12px 0; color: #888;">
          请先选择一级渠道
        </div> -->
      </el-col>
    </el-row>
  </div>

  <!-- 新增/修改 -->
  <createDrawer
    v-if="showCreateDrawer"
    v-model="showCreateDrawer"
    :roleType="roleType"
    :editRow="editRow"
    :parentDepart="parentDepart"
    @close="showCreateDrawer = false"
    @on-success="successHandler"
  ></createDrawer>

  <!-- tagsManageDialog -->
   <tagsManageDialog v-if="showTagsManageDialog"
    v-model="showTagsManageDialog"
    @close="showTagsManageDialog = false" />


  <el-dialog :close-on-click-modal="false" :visible.sync="showBatchEditTagDialog" width="680px" title="提示" append-to-body>
    <div class="batch-edit-content">
      <span>确定要给选中的账号批量{{ batnbatchEditTagOpt && batnbatchEditTagOpt.editType === 1 ? '新增' : '删除' }}</span> 
      <el-select size="mini" ref="selectTagRef" class="select-tag" v-model="checkTag" clearable placeholder="请选择渠道标签">
        <el-option v-for="item in tagList"
            :key="item.value"
            :value="item.value"
            :label="item.label">
          </el-option>
        </el-select>
      <span>标签吗？</span>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="default" @click="checkTag = ''; showBatchEditTagDialog = false;">取消</el-button>
      <el-button type="primary" @click="batchEditTagSubmit">保存</el-button>
    </div>
  </el-dialog>

</div>
</template>
<script>
import NP from 'number-precision'
import tagsManageDialog from '@/page/component/sections/team/tags-manage-dialog'
import createDrawer from '@/page/component/sections/team/account-drawer'
import { douyinM2SPageList, getSecondaryChannelPageList, getPrimaryChannelPageList, setTeamAccountStatus, batchUpdateBd } from '@/service/apis/group'
import { getUserId, getRoletype } from '@/utils/getUser';
import { getChannelTagList, batchAddTag, batchDeleteTag } from '@/service/apis/supShopTag'
const dayjs = require('dayjs')
const domain = location.host.replace('bd-pc', 'bd')
// const baseLink = location.protocol + '//' + domain + '/#/?qdAccountId='
const baseLink = 'https://bd.jwhdz.com/#/?qdAccountId='

export default {
  components: { 
    createDrawer,
    tagsManageDialog
   },
   computed: {
    cOrderLink () {
      return `${baseLink}${getUserId()}`
    },
    roleType () {
      return getRoletype()
    }
   },
  data () {
    return {
      showBatchEditDialog: false,
      showTagsManageDialog: false,
      isOrNot: [
        {
          value: true,
          label: '是'
        },
        {
          value: false,
          label: '否'
        }
      ],
      form: {
        tagCode: '',
        mobilePhone: '',
        nickName: '',
        createDate: [],
        hasTag: ''
      },
      form1: {
        tagCode: '',
        mobilePhone: '',
        nickName: '',
        hasTag: ''
      },
      batchEditForm: {
        oldBd: '',
        newBd: ''
      },
      pageInfo: {
        current: 1,
        size: 10,
        sizes: [ 10, 20, 30, 50, 100 ],
        pages: 0,
        total: 0
      },
      pageInfo1: {
        current: 1,
        size: 10,
        sizes: [ 10, 20, 30, 50, 100 ],
        pages: 0,
        total: 0
      },
      qdAccountId0: '',
      groupList1: [],
      multipleSelection1: [],
      multipleSelection: [],
      isLoading: false,
      tableData: [],
      tableData1: [],
      isLoading1: false,
      editRow: null,
      parentDepart: null,
      showCreateDrawer: false,
      currentRow: null,
      batnbatchEditTagOpt: null,
      showBatchEditTagDialog: false,
      tagList: [],
      checkTag: '', // 
    }
  },
  filters: {
    filterDate (date) {
      if (date) {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  created () {
    this.getChannelTagList()
    this.$nextTick(() => {
      this.getList1()
      this.getList()
      this.getAccountList()
    })
  },
  methods: {
    clearSelect (ref, keyname) {
      this[keyname] = []
      this.$refs[ref].clearSelection()
    },
    batchEditTagSubmit () {
      if (!this.checkTag) {
        this.$message.warning('请选择渠道标签')
        this.$refs.selectTagRef.focus()
        return
      }
      // 新增
      if (this.batnbatchEditTagOpt.editType === 1) {
        batchAddTag.call(this, {
          tagCode: this.checkTag,
          users: this.batnbatchEditTagOpt.list.map(item => ({
            accountId: item.accountId,
            nickName: item.nickName
          }))
        }).then(res => {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.showBatchEditTagDialog = false
          if (this.batnbatchEditTagOpt.type === 1) {
            this.getList1()
          } else {
            this.getList()
          }
        })
      } else {
        // 删除
        batchDeleteTag.call(this, {
          tagCode: this.checkTag,
          users: this.batnbatchEditTagOpt.list.map(item => ({
            accountId: item.accountId,
            nickName: item.nickName
          }))
        }).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          }) 
          this.checkTag = ''
          this.showBatchEditTagDialog = false
          if (this.batnbatchEditTagOpt.type === 1) {
            this.getList1()
          } else {
            this.getList()
          }
        })
      }
    },
    async getChannelTagList () {
      this.isLoading = true
      const res = await getChannelTagList.call(this)
      this.isLoading = false
      this.tagList = [...(res || [])].map(item => ({
        label: item.tagLabel,
        value: item.tagCode
      }))
    },
    /*
    * opt.type 1 1级渠道 2 二级渠道
    * opt.editType 1 新增 2 删除
    * list */
    batchEditTag(opt) {
      this.checkTag = ''
      this.batnbatchEditTagOpt = opt
      this.showBatchEditTagDialog = true
    },
    tableRowClassName ({ row }) {
      if (this.currentRow && row.id === this.currentRow.id) {
        return 'highlight-row'
      }
      return ''
    },
    handleCurrentChange (val) {
      this.currentRow = val
      this.getList()
    },
    handleSelect1 (selection, row) {
      const index = this.multipleSelection1.findIndex(item => item.id === row.id)
      if (selection.includes(row)) {
        if (index === -1) {
          this.multipleSelection1.push(row)
        }
      } else {
        if (index !== -1) {
          this.multipleSelection1.splice(index, 1)
        }
      }
    },
    handleSelectAll1 (selection) {
      if (selection.length === 0) {
        // 取消全选
        this.multipleSelection1.forEach(row => {
          const index = this.multipleSelection1.findIndex(item => item.id === row.id)
          if (index !== -1) {
            this.multipleSelection1.splice(index, 1)
          }
        })
      } else {
        // 全选当前页
        selection.forEach(row => {
          const index = this.multipleSelection1.findIndex(item => item.id === row.id)
          if (index === -1) {
            this.multipleSelection1.push(row)
          }
        })
      }
    },
    handleSelect (selection, row) {
      const index = this.multipleSelection.findIndex(item => item.id === row.id)
      if (selection.includes(row)) {
        if (index === -1) {
          this.multipleSelection.push(row)
        }
      } else {
        if (index !== -1) {
          this.multipleSelection.splice(index, 1)
        }
      }
    },
    handleSelectAll (selection) {
      if (selection.length === 0) {
        // 取消全选
        this.multipleSelection.forEach(row => {
          const index = this.multipleSelection.findIndex(item => item.id === row.id)
          if (index !== -1) {
            this.multipleSelection.splice(index, 1)
          }
        })
      } else {
        // 全选当前页
        selection.forEach(row => {
          const index = this.multipleSelection.findIndex(item => item.id === row.id)
          if (index === -1) {
            this.multipleSelection.push(row)
          }
        })
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    getAccountList () {
      // 超管 - 查看所有一级 1
      douyinM2SPageList.call(this, {
        one: 1,
        current: 1,
        size: 1000
      }).then(res => {
        this.groupList1 = [...(res.records || [])].map(item => {
          return {
            ...item,
            name: `${item.nickName}(${item.mobilePhone})`
          }
        })
      })
    },
    batchEditFormClear () {
      this.qdAccountId0 = ''
      this.batchEditForm.oldBd = ''
      this.batchEditForm.newBd = ''
    },
    batchEditSubmit () {
      if (!this.qdAccountId0) {
        this.$message.error('请选择一级渠道')
        this.$refs.qdSelect.focus()
        return
      }
      if (!this.batchEditForm.oldBd) {
        this.$message.error('请输入修改前的佣金比例')
        return
      }
      if (!this.batchEditForm.newBd) {
        this.$message.error('请输入修改后的佣金比例')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '更新中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      batchUpdateBd.call(this, {
        oldBd: NP.times(this.batchEditForm.oldBd, 1000),
        newBd: NP.times(this.batchEditForm.newBd, 1000),
        parentIdList: [this.qdAccountId0]
      }).then(res => {
        this.$message.success(res || '批量修改成功')
        this.batchEditFormClear()
        this.showBatchEditDialog = false
        this.getList()
      }).finally(() => {
        loading.close()
      })
    },
    validateNumberInput(field, value) {
      // 使用正则表达式只允许输入数字和小数点
      let numericValue = value.replace(/[^\d.]/g, '') // 只保留数字和小数点
        .replace(/^(\d+\.?\d*)(.*)$/, '$1') // 只保留第一个小数点
        // .replace(/^(\d+\.?\d{0,2}).*$/, '$1') // 限制小数点后最多两位

      // 整数
      // numericValue = numericValue.replace(/[.]/g, '') // 去掉小数点
      
      this.batchEditForm[field] = numericValue
    },
    editHander (row) {
      this.editRow = row
      this.showCreateDrawer = true
    },
    flagChange (e, row) {
      const loading = this.$loading({
        lock: true,
        text: '更新中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      setTeamAccountStatus.call(this, row.accountId).then(res => {
        this.getList()
        this.$message.success('更新状态成功')
      }).finally(() => {
        loading.close()
      })
    },
    getList () { 
      // if (!this.currentRow) {
      //   return false
      // }
      this.isLoading = true
      this.tableData = []
      const opt = {
        current: this.pageInfo.current,
        size: this.pageInfo.size
      }
      if (this.currentRow && this.currentRow.accountId) {
        opt.parentId = this.currentRow.accountId
      }
      if (this.form.mobilePhone) {
        opt.mobilePhone = this.form.mobilePhone
      }
      if (this.form.nickName) {
        opt.nickName = this.form.nickName
      }
      if (this.form.tagCode) {
        opt.tagCode = this.form.tagCode
      }
      if (this.form.hasTag !== '') {
        opt.hasTag = this.form.hasTag
      }
      if (this.form.createDate && this.form.createDate.length) {
        opt.createTimeStart = dayjs(this.form.createDate[0]).format('YYYY-MM-DD') + ' 00:00:00'
        opt.createTimeEnd = dayjs(this.form.createDate[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      getSecondaryChannelPageList.call(this, opt).then((res) => {
        const {records, pages, total} = res
        this.pageInfo.total = total || 0
        this.pageInfo.pages = pages || 0
        this.tableData = [...(records || [])].map(item => {
          return {
            ...item,
            cOrderLink: `${baseLink}${item.accountId}`
          }
        })
      }).finally(() => {
        this.isLoading = false
      })
    },
    getList1 () {
      this.isLoading1 = true
      this.tableData1 = []
      const opt = {
        current: this.pageInfo1.current,
        size: this.pageInfo1.size
      }
      if (this.form1.mobilePhone) {
        opt.mobilePhone = this.form1.mobilePhone
      }
      if (this.form1.nickName) {
        opt.nickName = this.form1.nickName
      }
      if (this.form1.tagCode) {
        opt.tagCode = this.form1.tagCode
      }
      if (this.form1.hasTag !== '') {
        opt.hasTag = this.form1.hasTag
      }
      getPrimaryChannelPageList.call(this, opt).then((res) => {
        const {records, pages, total} = res
        this.pageInfo1.total = total || 0
        this.pageInfo1.pages = pages || 0
        this.tableData1 = [...(records || [])].map(item => {
          return {
            ...item,
            cOrderLink: `${baseLink}${item.accountId}`
          }
        })
      }).finally(() => {
        this.isLoading1 = false
      })
    },
    // 新增、修改回调
    successHandler () {
      this.showCreateDrawer = false
      this.getList()
      this.getList1()
    }
  }
}
</script>
<style scoped>
.link {
  padding-left: 24px;
  font-size: 14px;
}
.shadow-box {
  padding: 12px 24px 16px 24px;
}

.batch-edit {
  display: flex;
  align-items: center;
}
.batch-edit .input {
  width: 120px;
  margin: 0 6px;
}
.page-main_box {
  width: 100%;
  height: auto;
}

::v-deep .el-table .highlight-row {
  background: oldlace;
}
.batch-btn {
  font-size: 12px;
  color: #333;
  margin-top: 4px;
  height: 30px;
  display: flex;
  align-items: center;
}
.batch-btn span {
  margin-right: 8px;
}
.batch-edit-content {
  display: flex;
  align-items: center;
  align-items: center;
}
.select-tag {
  margin: 0 6px;
  min-width: 200px;
}
.code-list {
  width: 100%;
}
.row-box {
  width: calc(100vw - 280px);
}
.search-item {
  margin-right: 6px;
}
</style>